import { EDU_IMG_PRE_PATH, LAW_IMG_PRE_PATH, GROUP_IMG_PRE_PATH, GOV_IMG_PRE_PATH, LINK_PRE_PATH } from './index';

export const headBg = EDU_IMG_PRE_PATH + 'pc/aaa6db883da9a09773e46769a8722e1dd81b08f3f5c96ab7e25275298819185f.jpg';
export const headBgM = EDU_IMG_PRE_PATH + 'm/731b54a45ab7d1d4c3e0882ca58e1df3d46d790f5dd74e42b239c730305b92fa.jpg';
export const frameSrc = EDU_IMG_PRE_PATH + 'pc/90cd32e219a4fd5f7ff75145f656b3b8e29ebee3188f9bd90d80512c1fbb01a8.jpg';
export const frameSrcM = EDU_IMG_PRE_PATH + 'm/ac441bac6d164b51d407f4882429fc0e73c85b142c7617d17ce8694079fa357a.jpg';

export const challenge = [
  {
    icon: EDU_IMG_PRE_PATH + 'pc/a760015a1f24e9c5e975c5d91d48409514682fd2085c41ced17873435787a9a9.png',
    title: '教育资源不均，乡镇基础薄弱',
    desc: '城乡教育资源分配不均衡，欠发达地区教育资源不足，资金短缺，教育基础设施薄弱',
  },
  {
    icon: EDU_IMG_PRE_PATH + 'pc/030a0ef289ba3b3e316b9c45b345994fef8e5086012b0161e2a249c9f3120b81.png',
    title: '教学研管等场景难常态化应用',
    desc: '教育流程未全面打通，无法实现创新特色应用，难以满足教学、教研、办公、管理一体化需求',
  },
  {
    icon: EDU_IMG_PRE_PATH + 'pc/a4d75affa16921c9768f3e86654e5908312b76536a482eb1e78b4761dffbc3cf.png',
    title: '校园音视频系统应用孤岛化',
    desc: '视频会议、线上授课、录播教室相互独立，众多品牌无法互联互通，亟需打破各系统的孤岛式应用现状',
  },
  {
    icon: EDU_IMG_PRE_PATH + 'pc/438c4f4a88b1cc5f7d674ea8a02d51119f866aa9ce5261562bb3797c7b4a09d2.png',
    title: '学校无专职技术人员，运维成本高',
    desc: '基层学校无配备技术管理人员，传统教学系统长期缺乏维护管理，使用及维护门槛高',
  },
];
export const frame = [
  {
    title: '优质资源共享',
    icon: EDU_IMG_PRE_PATH + 'pc/7c74c21c687138495e8994a03fe49f01e6ad3899b0056f890ffffd2641ea313f.png',
  },
  {
    title: '贯穿教学研管',
    icon: EDU_IMG_PRE_PATH + 'pc/c7d33fbc161ab456aac6ca55d527dcef59aebdfc7f068f721bd8e660fa3dac7c.png',
  },
  {
    title: '多系统融合互通',
    icon: LAW_IMG_PRE_PATH + 'pc/9a401e6f963dbfae539d904cea119af56658ef3786911cfc2703411c4101ba84.png',
  },
  {
    title: '降低运维成本',
    icon: GROUP_IMG_PRE_PATH + 'pc/fa946d09390c3fcd3af2352b6b5bcd62b7bf84a5fbfa8bb4630e69090dcb790d.png',
  },
];
export const advantage = [
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/68979ad392e91c378cf24b24c95fffd44bfc3d080c65373c0a037be1314f36c8.png',
    title: '超融合应用',
    desc: '视频会议、直播、录播、数据、语音等统一媒体接入能力，可融合多品牌录播、视频会议、监控、安防等系统，全域视频能力中台，构建教/学/研/评/管/办公一站式生态体系',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/faf1f6749cd9696565108b7f79fbfdd524c6bfce90020c55138f9eaf87719206.png',
    title: '全场景连接',
    desc: '提供全连接视频终端，满足各类教学空间、办公会议、集控中心、户外移动场景、家庭等全场景接入，突破空间及地域限制，实现全连接、常态化、多场景的强扩展性应用',
  },
  {
    icon: EDU_IMG_PRE_PATH + 'pc/2732eb8a44e1ad1d8a067523a0e5bf69a35e2fa5c3b623fdf26759b8dc086cdd.png',
    title: '灵活化部署',
    desc: '平台提供公有云、私有云、专有云等多种部署方式，基于各级教育部门及机构业务，灵活开展特色化部署，可实现数据本地流转，资源文件本地存储',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/ba7fb7ba0a0f40557012ce829250051134a7fa360fd790dde54e3b843ca4fa6a.png',
    title: '高安全保密',
    desc: '国密算法端到端全链路加密，适配各类信创CPU芯片、操作系统和数据库，全面兼容国产化平台，符合国家自主安全战略',
  },
  {
    icon: EDU_IMG_PRE_PATH + 'pc/6a2161742892a9fb040270ee993fa78fc033e954dfaabb16c39edbb7e2a96953.png',
    title: '高品质体验',
    desc: '全自研底层技术，具备完全自主核心知识产权，超强网络适应性，有效保障超大规模、超低延时的1080P/4K超高清体验',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/72abb4a6fb3e84800a01164b1497efa20ae197c93d1213928156bb947035a3b0.png',
    title: '开放式集成',
    desc: '全面开放API/SDK，深度融合教育应用场景，打造音视频数字基座，促进学校音视频业务互通的基础能力提升',
  },
];
export const scene = [
  {
    title: '专递课堂',
    desc: '实现优秀主讲老师本地教学的同时，远程为多地区、多课堂学生上课',
    pcUrl: EDU_IMG_PRE_PATH + 'pc/fb310447437efb6cb9343c8c2ddeb7ac61954129dcff3e35f135d2f27f6371f5.jpg',
  },
  {
    title: '双师课堂',
    desc: '真人1:1还原主讲老师课堂，偏远地区学生可实时与老师课堂互动',
    pcUrl: EDU_IMG_PRE_PATH + 'pc/9bf6786454db487c08e6cd35f35fa748f9497e0d618b15731737cf7881f0e129.jpg',
  },
  {
    title: '停课不停学 ',
    desc: '支持万方接入，可快速搭建线上云课堂平台，实现大规模在线教学',
    pcUrl: EDU_IMG_PRE_PATH + 'pc/6b3a4b73d518d420565f22cd0caeb3a519a04fb5a8e0c4464e8324f0d33249f5.jpg',
  },
  {
    title: '家校互通',
    desc: '发挥名师示范效应，组建网络研修共同体，提升区域师资教研水平',
    pcUrl: EDU_IMG_PRE_PATH + 'pc/7be73150727eec27ff86c6006f5cd5825e8daf4dcba1ffdb8e5a09aad7d9e8cb.jpg',
  },
  {
    title: '名师课堂',
    desc: '满足大规模4K互动视频商务洽谈需求，可实现异地多方音频、视频、数据共享等远程协作',
    pcUrl: EDU_IMG_PRE_PATH + 'pc/15044cc518d1e8e4096a152b0ce3bd03e242b1ee724758e857470f846f74fec7.jpg',
  },
  {
    title: '网络教研',
    desc: '突破时空限制开展远程教学研讨，支持课件共享、实时标注等',
    pcUrl: EDU_IMG_PRE_PATH + 'pc/78814ca5cc7551240cf8c6232f6588ac95603a429e49e8bbfef0e347032f2115.jpg',
  },
  {
    title: '教师培训',
    desc: '支持区域大规模视频会议进行教育课堂研讨，各终端可随时随地入会',
    pcUrl: EDU_IMG_PRE_PATH + 'pc/342951493fe3d86d0dcc8dc73f9ef057d6105b77e20e3235a042b8adeb0d1533.jpg',
  },
  {
    title: '督导巡课',
    desc: '校园管理部门可对教学过程进行实时抽样督导，了解教学实况',
    pcUrl: EDU_IMG_PRE_PATH + 'pc/fec801e79f9e20f86c88bc04679724750815b17aef4b0024e5382e5df2f41103.jpg',
  },
];
export const caseList = [
  [
    {
      logo: EDU_IMG_PRE_PATH + 'pc/f2d71eddf706e25974fb2eb9e00b8e2344a43e0966191fb9f901e6799c01d10a.png',
      title: '云南省教育厅',
      desc: '云南省教育厅携手小鱼易连，搭建服务教育应用的教育融合云视频平台以及千余套互动教学终端系统，实现全省1+N远程互动课堂、教研共同体、协同办公（日常工作会议、控辍保学、疫情防控调度会议、线上家长会）、思政课堂等多元常态化应用。2020年，云南省教育厅举办了“春季开学第一课”培训活动。通过云视频在互联网环境下，直播主课堂与直播分课堂建立高清视频连接，让全省5万多间教室的200万师生实现在线同步上课。',
      link: LINK_PRE_PATH + '175774',
    },
    {
      logo: EDU_IMG_PRE_PATH + 'pc/1626da1f132be39edac2ba90d4811c784baa982cb43748e393784c57027805d3.png',
      title: '内蒙古包头市教育局',
      desc: '疫情面前勇往无前，云端上课温情不减。内蒙古包头市教育局，借助小鱼易连，积极组织全市近10万名初高中学生在家上课学习，通过云视频进行“远程在线授课、互动答疑”，老师和学生实时在线面对面“空中课堂”学习。针对高三学生， “互动课堂”实现对全市15000名高三学生全覆盖，将原本校内复习备考的课程搬到线上，让孩子们从容应对高考。',
      link: LINK_PRE_PATH + '1063',
    },
    {
      logo: EDU_IMG_PRE_PATH + 'pc/6eb17da31e6fb2b86f88accf0987277009fde3494601539804763e2dcbd0c7fc.png',
      title: '广东省惠州市教育局',
      desc: '广东省惠州市教育局携手小鱼易连，采用“1+N”与“双师课堂”相结合形式，为下辖7个县（区）和贵州省黔西南州7个县（市）的123个分会场，进行“班主任心理健康教育专项”线上远程培训活动。云视频打破时间和物理空间桎梏，让2.65万名老师实现“同屏相连、同台培训”。',
      link: LINK_PRE_PATH + '1063',
    },
    {
      logo: EDU_IMG_PRE_PATH + 'pc/bd1413e00b4525b358535e5b4918f5cc1719850eee2d19653c5a4097418bb2bd.png',
      title: '浙江省舟山市岱山县教育局',
      desc: '浙江省舟山市岱山县教育局通过小鱼易连云视频打造智慧课堂，以网络课堂形式确保学生“停课不停学”。师生通过云视频高清连线，开展线上授课、实时互动的在线课堂，课后学生通过录屏回看进行复习巩固，进一步提升学习效果。同时，云视频也加强了老师与家长之间实时沟通，能够在复课之前及时了解学生们的情况。',
      link: LINK_PRE_PATH + '954',
    },
    {
      logo: EDU_IMG_PRE_PATH + 'pc/e650a5015b1118f44d8667ca0d3a5cbe455a424fef6283ee056d255c780d336d.png',
      title: '云南省施甸县教育局',
      desc: '云南省施甸县为推动全县教育优质均衡发展，运用信息化手段扩大优质教育资源覆盖面的有效机制建设，深入开展“三个课堂”常态化应用。施甸县携手小鱼易连，基于教育网及互联网，构建全县13个乡镇的互联互通教学应用服务体系，为近百所学校搭建“超高清、低延时、强互动”的互动云课堂。',
      link: LINK_PRE_PATH + '7125bf',
    },
    {
      logo: EDU_IMG_PRE_PATH + 'pc/ad76eaa5270509fa13e3e9f2e50c6fbf7defff06b6fbaebf6c3e8ce599c5f075.png',
      title: '浙江省宁波市鄞州区教育局',
      desc: '在浙江省宁波市鄞州区，小鱼易连为“居家观察”的老师和学生搭建线上“超高清、低延时、强互动”的高品质“云课堂”。在校师生在互动教室内上课，居家的老师和学生使用电脑、平板和手机，通过互联网高清接入“云课堂”，进行互动教学。小鱼易连创新的互动教学模式，保障了鄞州区疫情期间教学活动正常进行，实现“停课不停学”。',
      link: LINK_PRE_PATH + '1063',
    },
  ],
  [
    {
      logo: EDU_IMG_PRE_PATH + 'pc/ca6edc857b9a514b8d1be51d4ad01d1a5f63d393b5fcaf48b2e2f7f17579b1ff.png',
      title: '温州市瓯海区教育局',
      desc: '瓯海教育局携手小鱼易连，共同打造瓯海教育云视频平台，实现了教育局、辖区110余所中小学和幼儿园、6个直属机构、全区5000多位公办教师和教职工的全覆盖，满足远程视频会议、办公协同、网络教研、在线听评课、线上师训、活动直播等教育教学、办公场景应用，为全区的数字教育及协作沟通提供强有力保障，并与教育教学相关业务进行深度融合，为全区教育信息化升级工作提供新思路。',
      link: LINK_PRE_PATH + '5ec7ce',
    },
    {
      logo: EDU_IMG_PRE_PATH + 'pc/659ca0ad3a40a95d4e45daef826db3be90759a3722183ffcb1c2aa81c4c7a092.png',
      title: '巴蜀云校',
      desc: '巴蜀云校是应用5G和云视频等先进技术打造的巴蜀教育综合体，致力于通过小鱼易连云视频，联动各合作区域智慧教室，将巴蜀中学优质教育教学资源输送到友好学校，实现优质教育资源的共享共建。基于云视频打造的适合初级中学、高完中、高级中学各学龄阶段的线上“面对面”教育教学系统，为推进教育公平铺平道路。',
      link: LINK_PRE_PATH + '5befeb',
    },
  ],
];
